import PropTypes from 'prop-types'
import { useContext } from 'react'

import { ToggleViewingModeStateContext } from '@/components/Layout/index.js'

export const Conditional = ({ isShow, children }) => {
    return isShow && children
}

// 社外秘
export const InternalUse = ({ children }) => {
    const { isJobseekerViewing } = useContext(ToggleViewingModeStateContext)
    return <Conditional isShow={!isJobseekerViewing}>{children}</Conditional>
}
InternalUse.propTypes = {
    children: PropTypes.node.isRequired,
}
